/*
 * Module for the ACH File Benefit job criteria page
 */
rs.module("content/jobs/criteria/achfilebenefit",

    ["common/visibility"],

    function (visibility) {

        // Initialize the page
        function initialize(jsSelectors, fileTypes, backendUrls) {
            var criteria = $.js(jsSelectors.criteria);

            var fileTypeLoadingSpinner = criteria.js(jsSelectors.fileTypeLoadingSpinner);
            var createRecreateLoadingSpinner = criteria.js(jsSelectors.createRecreateLoadingSpinner);

            var fileTypeSelect = criteria.js(jsSelectors.fileTypeSelect);
            var createRecreateRadioContainer = criteria.js(jsSelectors.createRecreateRadioContainer);
            var createRadio = criteria.js(jsSelectors.createRadio);
            var recreateRadio = criteria.js(jsSelectors.recreateRadio);
            var gridContent = criteria.js(jsSelectors.gridContent);

            // Register fileTypeSelect changed event
            fileTypeSelect.change(() => updateChildControls(true));

            // Register createRecreateRadio changed events
            createRadio.change(() => updateChildControls(false));
            recreateRadio.change(() => updateChildControls(false));

            // Handle dynamic display of child controls
            function updateChildControls(typeChanged) {

                // get selected file type
                var selectedFileType = fileTypeSelect.val();

                // determine what has changed so we can show/hide the appropriate spinner 
                if (typeChanged) {
                    fileTypeLoadingSpinner.show();

                    // reset checkboxes
                    createRadio.setChecked();
                    recreateRadio.setChecked(false);
                }
                else {
                    createRecreateLoadingSpinner.show();
                }

                // display appropriate grid based on file type
                if (selectedFileType == fileTypes.lumpSum) {
                    _updateGridContentFrom(
                        backendUrls.getBenefitPayrollBatches,
                        {
                            isLumpSum: true,
                            recreate: recreateRadio.is(':checked')
                        },
                        true);
                }
                else if (selectedFileType == fileTypes.lumpSumReissueRejected) {
                    _updateGridContentFrom(
                        backendUrls.getReissueDirectDeposits,
                        {
                            isLumpSum: true
                        },
                        false);
                }
                else if (selectedFileType == fileTypes.periodic) {
                    _updateGridContentFrom(
                        backendUrls.getBenefitPayrollBatches,
                        {
                            isLumpSum: false,
                            recreate: recreateRadio.is(':checked')
                        },
                        true)
                }
                else {
                    _updateGridContentFrom(
                        backendUrls.getReissueDirectDeposits,
                        {
                            isLumpSum: false
                        },
                        false);
                }

                // Update grid content from a url with parameters 
                function _updateGridContentFrom(url, parameters, showRecreateRadioContainer) {

                    visibility.setVisible(createRecreateRadioContainer, showRecreateRadioContainer);

                    $.get(url,
                        parameters,
                        function done(html) {
                            gridContent.html(html);

                            fileTypeLoadingSpinner.hide();
                            createRecreateLoadingSpinner.hide();
                        }
                    );
                }
            }
        }

        var exports = {
            initialize: initialize,
        };

        return exports;
    }
);